import css from '../assets/images/css.png'
import figma from '../assets/images/figma.png'
import git from '../assets/images/git.png'
import html from '../assets/images/html.png'
import javascript from '../assets/images/javascript.png'
import mu5 from '../assets/images/mu5.png'
import node from '../assets/images/node.png'
import react from '../assets/images/react.png'
import redux from '../assets/images/redux.png'
import sass from '../assets/images/sass.png'
import typescript from '../assets/images/typescript.png'
import firebase from '../assets/images/firebase.png'
import bootstrap from '../assets/images/bootstrap.png'
import tailwindcss from '../assets/images/tailwindcss.png'
import nextjs from '../assets/images/nextjs.svg'

// Profile
import profile from '../assets/images/tony.JPG'

// Works section
import project from '../assets/images/project.png'
import project_light from '../assets/images/project_light.png'
import project1 from '../assets/images/project1.png'
import project2 from '../assets/images/project2.png'
import project3 from '../assets/images/project3.png'
import project4 from '../assets/images/project4.png'

//

export default {
    profile,

    project3,
    project2,
    project1,
    project,
    project_light,
    project4,

    tailwindcss,
    bootstrap,
    firebase,
    css,
    figma,
    git,
    html,
    javascript,
    mu5,
    node,
    react,
    redux,
    sass,
    typescript,
    nextjs,
}
